import { render, staticRenderFns } from "./FaqAccordion.vue?vue&type=template&id=faef585a&scoped=true&lang=pug&"
import script from "./FaqAccordion.vue?vue&type=script&lang=js&"
export * from "./FaqAccordion.vue?vue&type=script&lang=js&"
import style0 from "./FaqAccordion.vue?vue&type=style&index=0&id=faef585a&lang=scss&scoped=true&"


/* normalize component */
import normalizer from "!../../../node_modules/@vue/cli-service/node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  null,
  "faef585a",
  null
  
)

export default component.exports